<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WMcCMI/tc-custom/9781460389348.jpg?1699985098200" alt="This image is the cover for the book Silent Night Pursuit, Roads to Danger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Night Pursuit, Roads to Danger
      </h1>
      <p class="bookDescription body article font2">
        <p>RACE AGAINST TIME <br/><br/>Lacey Phillips believes Captain Wade Spencer knows something about her brother's mysterious death. So she throws caution to the wind and tracks him down on Christmas Eve looking for answers. Wade tries to turn her awayuntil bullets start to fly. He doesn't want to take the stubborn beauty on his life-or-death mission to find out the truth about how Wade's past may have cost her brother his life. But with killers lurking everywhere, he has to protect herespecially when she breaches the walls around his heart. Can Wade and his faithful service dog keep Lacey alive long enough to figure out who's targeting them? <br/><br/>ROADS TO DANGER: Family secrets resurface</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katy Lee
      </h2>
      
      <p class="authorDescription body article">Best-selling and award-winning author Katy Lee writes novels filled with romance, suspense and inspiration. She lives in the rugged beauty of the Utah mountains where she is also a special education teacher at a school for international students. Katy loves to knit warm wooly things while plotting her next suspense story. Keep up with Katy at KatyLeeBooks.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1b380b8